import React from "react";
import { Link } from "react-router-dom";
import GardenSingleProduct from "./Garden";
import { Breadcrumbs } from "./../../Breadcrumb/index";
import { useEffect } from "react";

export default function GardenProduct() {
  useEffect(() => {
      const style = document.createElement("style");
      style.innerHTML = `
        @media (max-width: 998px) {
          .custom-mobile-margin {
            margin-top: 10% !important;
          }
        }
          @media (max-width: 750px) {
          .custom-mobile-margin {
            margin-top: 13% !important;
          }
        }
          
      `;
      document.head.appendChild(style);
    
      return () => {
        document.head.removeChild(style);
      };
    }, []);

  return (
    <div className="productPage">
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-12 custom-mobile-margin">
            <div className="row">
              <Breadcrumbs currentPathName="Brass and bronze " />
              <div className="col-md-6">
                <ul className="list-inline shop-top-menu pb-3 pt-1">
                  <li className="list-inline-item">
                    <Link
                      className="h3 text-dark text-decoration-none mr-3 text-uppercase"
                      to="/gardenProduct"
                    >
                      Brass and bronze
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <GardenSingleProduct />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
